export default __webpack_public_path__ + "static/media/bahrain.4f9d5387.png";